import createReducer from '../../utils/createReducer';
import { storeUser, getUserbyToken } from '../../services/user';
import { USER_FOUND } from 'redux-oidc';

import { URL } from '../../config/lirasys';

export const USER = 'USER';

export const getRoles = user => {
  return user.roles
    ? user.roles.split(' ')
    : [];
};

const checkLicenses = r => r.some(r =>
  r === 'licenca_de_uso_software_lira_log_perfil.cadastro.mr'||
  r === 'licenca_de_uso_software_lira_log_perfil.consulta.mr');
const verifyRoles = (roles) => roles ? checkLicenses(roles): roles;
const clearUser = () => {
  localStorage.removeItem('bearer');
  localStorage.removeItem('user');
  sessionStorage.clear();
};

export default createReducer({
  // Update token if OIDC has found user
  // Need to be done due to `oidc` package silentRenew flow do not allow a 'simple' way of updating
  // the bearer token.
  [USER_FOUND]: (state, { payload: { access_token: accessToken }}) => {
    if(!verifyRoles(getRoles( getUserbyToken(accessToken)))){
      clearUser();
      window.location.assign(URL);
    }
    else
      storeUser(accessToken);
    return state;
  },

  [USER]: (state, { user }) => ({
    ...state,
    ...user
  })
});

export const userAction = user => ({
  user,
  type: USER
});
